const slideBarRouter = [
  {
    path: '/serve-list',
    name: 'ServeList',
    component: () => import('@/views/slideBar/serveList'),
    meta: {
      title: '服务订单'
    }
  }
]

export default slideBarRouter
